import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Container, CardBody, Button, Card } from 'reactstrap';
import { DataTable, Column, PreviewHTML } from 'vivace-fluent-motion';
import { Switch, FormControlLabel } from '@material-ui/core';
import ComponentesDescarte from '../../common/components';
import ModalDescarte from '../../modais/descarte';
import ModalPeso from '../../modais/peso';
import DescarteApi from '../../descarte.api';
import * as commonActions from '@common/common.action';
import * as actions from './store/descarte.action';
import { useSelector, useDispatch } from 'react-redux';
import Sepultamento from '../../common/components/Sepultamento';
import Padrao from '../../common/components/Padrao';
import { useReactToPrint } from 'react-to-print';
import * as DefautValues from '@common/util/defaultValues';
import SelectComponent from '@componentes/select/select.component';
import Especial from '../../common/components/Especial';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from '../../../../helpers/intlMessage';
import { injectIntl, useIntl } from 'react-intl';

 function Descarte(props) {
  const intl = useIntl();
  const [selectFilter, setSelectFilter] = useState('');
  const [list, setList] = useState([]);
  const [selectGrid, setSelectGrid] = useState(0);
  const [search, setSearch] = useState(false);
  const [modalFiltros, setModalFiltros] = useState(false);
  const [isEspecial, setIsEspecial] = useState(false);
  const [isSepultamento, setIsSepultamento] = useState(false);
  const [showModalDescarte, setShowModalDescarte] = useState(false);
  const [showModalPeso, setShowModalPeso] = useState(false);
  const [totalItensPage] = useState(20);
  const [totalItens, setTotalItens] = useState(0);
  const [totalPeso, setTotalPeso] = useState(0);
  const [currentPesoId, setCurrentPesoId] = useState(0);
  const [currentPesoValue, setCurrentPesoValue] = useState(0);
  const [previewHTML, setPreviewHTML] = useState(false);
  const [sortName, setSortName] = useState('dataVencimento');
  const [ascending, setAscending] = useState(-1);
  const [listaImpressao, setListaImpressao] = useState([]);
  const [isFirst, setIsFirst] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);

  const {messages} = props.intl;

  const dispatch = useDispatch();
  const componentRef = useRef();

  const imprimir = useSelector(state => state.descarteCommon.imprimir);
  const motivo = useSelector(state => state.descarteCommon.motivo);
  const peso = useSelector(state => state.descarteCommon.peso);
  const observacao = useSelector(state => state.descarteCommon.observacao);
  const listaDescarte = useSelector(
    state => state.descarteMaterial.listaDescarte
  );
  const lista = useSelector(state => state.descarteMaterial.lista);
  const dataInicio = useSelector(state => state.descarteMaterial.dataInicio);
  const dataFim = useSelector(state => state.descarteMaterial.dataFim);
  const filtroValue = useSelector(state => state.descarteMaterial.filtroValue);
  const carregando = useSelector(state => state.commonReducer.showCarregando);
  const numPagina = useSelector(state => state.descarteMaterial.page);
  const common = useSelector(state => state.descarteCommon);
  const permissao = useSelector(
    state => state.descarteCommon.permissaoDescarteMateriais
  );
  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );

  const options = DefautValues.optionsFiltroDescarte
    .filter(x => x.value !== 'dtdescarte')
    .map(x => {
      return {...x, label: messages[x.label] ? messages[x.label] : x.label}
  });

  useEffect(() => {
    if (common.dataInicio && common.dataFim && common.filtroValue && !isFirst) {
      setSelectFilter(common.filtroValue);
      setDefaultValue(options.find(x => x.value === common.filtroValue));
      dispatch(actions.dataInicio(common.dataInicio));
      dispatch(actions.dataFim(common.dataFim));
      dispatch(actions.filtroValue(common.filtroValue));
      filtroValue && selectFilter && defaultValue && buscar();
      filtroValue && selectFilter && setIsFirst(true);
      if (common.tab !== '1') {
        setIsFirst(false);
        setSelectFilter('');
        dispatch(actions.dataInicio(''));
        dispatch(actions.dataFim(''));
        dispatch(actions.filtroValue(''));
      }
    }
  }, [common, filtroValue, selectFilter]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  function buscarDadosImpressao() {
    dispatch(commonActions.showFadeCarregando(true));

    const filtroTipo = isSepultamento
      ? DefautValues.tipoDescarteEmum.SEPULTAMENTO
      : isEspecial
        ? DefautValues.tipoDescarteEmum.ESPECIAL
        : DefautValues.tipoDescarteEmum.PADRAO;

    DescarteApi.listarDescarte(
      selectFilter,
      filtroValue,
      dataInicio,
      dataFim,
      1,
      totalItens,
      filtroTipo,
      sortName,
      ascending
    )
      .then(res => {
        if (res.data.length > 0) {
          setListaImpressao(res.data);
          setPreviewHTML(true);
        }
        dispatch(commonActions.showFadeCarregando(false));
      })
      .catch(() => dispatch(commonActions.showFadeCarregando(false)));
  }

  function ComponentHTML({ id }) {
    return (
      <div className='mv-visualizador-html'>
        <Card id={id}>
          <CardBody>
            <Container fluid>
              <div ref={componentRef}>
                {!isSepultamento && !isEspecial && (
                  <Padrao isDescarte={imprimir} lista={listaImpressao} />
                )}
                {isEspecial && (
                  <Especial isDescarte={imprimir} lista={listaImpressao} />
                )}
                {isSepultamento && <Sepultamento lista={listaImpressao} />}
              </div>
            </Container>
          </CardBody>
        </Card>
      </div>
    );
  }

  function changeFilter(e) {
    setSelectFilter(e.value);
    setDefaultValue(e);
    dispatch(actions.dataInicio(dataInicio));
    dispatch(actions.dataFim(dataFim));
    dispatch(actions.filtroValue(''));
  }

  function toggle(checked) {
    let checkboxes = document.getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        if (checked) {
          setSelectGrid(checkboxes.length);
          document
            .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
        } else {
          setSelectGrid(0);
          document
            .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
        }
      }
    }
  }

  function RenderizarFooter({ total }) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItens: 'center'
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItens: 'center'
          }}
        >
          <i
            className='mv-basico-stacktrace'
            style={{ fontSize: '20px', height: '18px' }}
          />{' '}
          <span style={{ marginTop: '2px' }} id='total-laudos'>
            <IntlMessage id = "dashboards.disposalMaterials.table.totalDiscard"/> {total}
          </span>
        </span>
      </div>
    );
  }

  function descartarItens() {
    let items = [];
    let pesoTotal = 0;
    let peso;
    let checkboxes = document.querySelectorAll('input[name=checkbox]:checked');
    for (let i = 0; i < checkboxes.length; i++) {
      lista.find(l => {
        if (l.idMaterial === Number(checkboxes[i].id)) {
          items.push({ idMaterial: l.idMaterial, laudoId: l.laudoId });
        }
      });
      peso = document.getElementById(`peso_${checkboxes[i].id}`);
      pesoTotal = pesoTotal + Number(peso.value);
    }

    setTotalPeso(pesoTotal);
    dispatch(actions.listaDescarte(items));
    setShowModalDescarte(!showModalDescarte);
  }

  function selectItem(e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document.querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    if (checkboxes.length === 0) {
      document.getElementById('select').checked = false;
    }
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[0].id === e.target.id
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
          }
        }
      }
    }
  }

  function showModalFiltros() {
    setModalFiltros(!modalFiltros);
  }

  function changeSepultamento(el) {
    setIsSepultamento(el);
    if (el) {
      setIsEspecial(!el);
    }
    buscar(false, false, { sepultamento: el, especial: false });
  }

  function changeEspecial(el) {
    setIsEspecial(el);
    if (el) {
      setIsSepultamento(!el);
    }
    buscar(false, false, { sepultamento: false, especial: el });
  }

  function onChangeSelect(e) {
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[0].id ===
          e.data.idMaterial.toString()
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
            document.getElementById(
              e.data.idMaterial.toString()
            ).checked = false;
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
            document.getElementById(
              e.data.idMaterial.toString()
            ).checked = true;
          }
        }
      }
    }
    let checkboxes = document.querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
  }

  function selectPeso(e) {
    setShowModalPeso(!showModalPeso);
    setCurrentPesoId(e.target.id);
    setCurrentPesoValue(e.target.value);
  }

  function insertSelect(dados) {
    const lista = [];
    dados.map(item => {
      return lista.push({
        laudoId: item.laudoId,
        idMaterial: item.idMaterial,
        exame: item.numeroExame,
        pedido: item.laudoId,
        diasavencer: item.diasAVencer,
        paciente: item.paciente,
        pacienteNomeSocial: item.pacienteNomeSocial,
        material: item.nomeMaterial, 
        dataPedido: CommonFunctions.formatData(item.dataPedido),
        idFrasco: item.idFrasco,
        dataRecebimento: item.dataRecebimento,
        dataVencimento: CommonFunctions.formatData(item.dataVencimento),
        peso: (
          <input
            className='peso-input'
            readOnly
            id={`peso_${item.idMaterial}`}
            value={item.pesoMaterial}
            onClick={e => selectPeso(e)}
          />
        ),
        tipo:
          item.tipoDescarte === 1
            ? <IntlMessage id = "dashboards.disposalMaterials.type.special"/>
              ? item.tipoDescarte === 2
              : <IntlMessage id = "dashboards.disposalMaterials.type.burial"/>
            : <IntlMessage id = "dashboards.disposalMaterials.type.standard"/>,
        select: (
          <input
            className='checkbox'
            name='checkbox'
            type='checkbox'
            id={item.idMaterial}
            onClick={e => selectItem(e)}
          />
        )
      });
    });

    setList(lista);
  }

  function changePeso(val) {
    const id = currentPesoId.replace('peso_', '');
    DescarteApi.atualizarPeso(Number(id), val)
      .then(res => {
        dispatch(commonActions.showAlerta('sucesso', res.message, 3000));
        document.getElementById(currentPesoId).value = val;
      })
      .catch(err => {
        dispatch(commonActions.showAlerta('erro', err.message, 3000));
      });
    setShowModalPeso(!showModalPeso);
  }

  function sendDescart() {
    descartarMateriais();
    setShowModalDescarte(!showModalDescarte);
  }

  function atualizarPagina(page) {
    buscar(null, null, null, page);
  }

  function buscar(field, order, tipo, nPage) {
    let DataInicio, DataFim, FiltroValue, FiltroTipo, SortName, SortAsc, Pagina;

    Pagina = numPagina;
    FiltroTipo = isSepultamento
      ? DefautValues.tipoDescarteEmum.SEPULTAMENTO
      : isEspecial
        ? DefautValues.tipoDescarteEmum.ESPECIAL
        : DefautValues.tipoDescarteEmum.PADRAO;

    if (tipo) {
      FiltroTipo = tipo.sepultamento
        ? DefautValues.tipoDescarteEmum.SEPULTAMENTO
        : tipo.especial
          ? DefautValues.tipoDescarteEmum.ESPECIAL
          : DefautValues.tipoDescarteEmum.PADRAO;
    }

    if (nPage) {
      Pagina = nPage;
    } else {
      dispatch(actions.page(1));
      Pagina = 1;
    }

    if (field) {
      SortName = field;
      SortAsc = order;
    } else if (sortName) {
      SortName = sortName;
      SortAsc = ascending;
    }
    if (selectFilter.indexOf('dt') >= 0) {
      DataInicio = dataInicio;
      DataFim = dataFim;
    } else {
      FiltroValue = filtroValue;
    }

    let executarValidacaoDeData = (selectFilter.indexOf('dt') >= 0);
    let result = {valid: true, message: ''};

    if (executarValidacaoDeData)
      result = CommonFunctions.validaData(DataInicio, DataFim, intl);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    dispatch(commonActions.showFadeCarregando(true));

    DescarteApi.listarDescarte(
      selectFilter,
      FiltroValue,
      DataInicio,
      DataFim,
      Pagina,
      totalItensPage,
      FiltroTipo,
      SortName,
      SortAsc
    )
      .then(res => {
        setSearch(true);
        setTotalItens(res.totalItems);
        showMessageByResults(res.totalItems);
        dispatch(actions.lista(res.data));
        insertSelect(res.data);
        dispatch(commonActions.showFadeCarregando(false));
      })
      .catch(err => {
        console.log(err);
        dispatch(commonActions.showFadeCarregando(false));
        showMessageByResults(0);
      });
  }

  function onSort(event) {
    //let orderAsc = event.sortOrder === 1;
    let field = event.sortField;
    setAscending(event.sortOrder);
    setSortName(field);
    dispatch(actions.page(1));
    lista.length > 0 && buscar(field, event.sortOrder);
  }

  function showMessageByResults(results) {
    if (results > 0) {
      /* const prural = results > 1 ? 's' : ''; */
      const mensagem = <IntlMessage id = "dashboards.disposalMaterials.dataSucessfully"/>
      dispatch(commonActions.showAlerta('sucesso', mensagem, 10));
    } else {
      dispatch(
        commonActions.showAlerta('alerta', <IntlMessage id = "dashboards.disposalMaterials.noResult"/>, 3000)
      );
    }
  }

  function descartarMateriais() {
    if (imprimir) {
      setTimeout(() => {
        handlePrint();
      }, 200);
      setListaImpressao(
        listaDescarte.map(x => lista.find(i => i.idMaterial === x.idMaterial))
      );
    }
    dispatch(commonActions.showFadeCarregando(true));
    const novalista = list;
    listaDescarte.forEach(element =>
      novalista.map((l, i) => {
        if (l.idMaterial === element.idMaterial) {
          document
            .getElementById(`peso_${element.idMaterial}`)
            .parentElement.parentElement.setAttribute('datacheck', 'false');
          novalista.splice(i, 1);
        }
        return novalista;
      })
    );
    toggle(false);
    const payload = {
      motivoDescarte: motivo.value,
      pesoTotal: peso,
      obs: observacao,
      materiais: listaDescarte
    };

    DescarteApi.descartar(payload)
      .then(res => {
        dispatch(commonActions.showAlerta('sucesso', res.message, 3000));
        //dispatch(actions.lista(novalista));
        setList(novalista);
        setSelectGrid(0);
        setTotalPeso(0);
        //setSelectFilter('');
        setTotalItens(novalista.length);
        dispatch(commonActions.showFadeCarregando(false));
      })
      .catch(err => {
        dispatch(commonActions.showFadeCarregando(false));
        err && dispatch(commonActions.showAlerta('erro', err.message, 3000));
      });
  }

  return (
    <React.Fragment>
      <ModalDescarte
        onModal={() => setShowModalDescarte(!showModalDescarte)}
        totalPeso={totalPeso}
        showModalDescarte={showModalDescarte}
        confirmar={() => sendDescart()}
        tipo={
          isSepultamento ? 'de sepultamento' : isEspecial ? 'especial' : null
        }
      />
      <ModalPeso
        onModal={() => setShowModalPeso(!showModalPeso)}
        onPeso={e => changePeso(e)}
        peso={currentPesoValue}
        id={currentPesoId}
        showModalPeso={showModalPeso}
        confirmar={() => { }}
      />
      <div className='mv-descarte-tab'>
        <PreviewHTML
          messageTitle = {<IntlMessage id = "dashboards.reports.printPreview"/>} 
          printLabel = {<IntlMessage id = "dashboards.reports.printOut"/>}
          visible={previewHTML}
          id='uniqueID'
          component={<ComponentHTML id='uniqueID' />}
          onOpened={e => setPreviewHTML(e)}
          onPrint={handlePrint}
        />
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col xs={3} style={{ maxWidth: 240 }}>
                    <SelectComponent
                      options={options}
                      placeholder={messages["dashboards.disposalMaterials.chooseOne"]}
                      value={defaultValue}
                      onChange={e => changeFilter(e)}
                    />
                  </Col>
                  {selectFilter && (
                    <div className='col-auto'>
                      {selectFilter && (
                        <ComponentesDescarte
                          component={selectFilter}
                          onPressEnter={buscar}
                        />
                      )}
                    </div>
                  )}
                  <Col>
                    <Button
                      style={{ height: '38px', width: '38px'}}
                      className='btn btn-primary'
                      disabled={!selectFilter}
                      onClick={() => buscar()}
                    >
                      <i className='icons-btn mv-basico-pesquisar'></i>
                    </Button>
                    {search && list.length > 0 && (
                      <Button
                        className='btn btn-descarte btn-danger'
                        onClick={() => descartarItens()}
                        disabled={!selectGrid}
                      >
                        {(list.length > 0 &&
                          permissao &&
                          selectGrid === totalItensPage) ||
                          (list.length > 0 &&
                            selectGrid === list.length &&
                            selectGrid > 1) ? (
                          <React.Fragment>
                            <i className='icons-btn mv-basico-excluir_todos'></i>{' '}
                            <IntlMessage id = "dashboards.disposalMaterials.discardAll"/>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <i className='icons-btn mv-basico-excluir'></i>{' '}
                            <IntlMessage id = "dashboards.disposalMaterials.toDiscard"/>
                          </React.Fragment>
                        )}
                      </Button>
                    )}
                  </Col>
                  {list.length > 0 && (
                    <Col>
                      <Button
                        className='btn btn-imprimir btn-success'
                        onClick={buscarDadosImpressao}
                        disabled={!search}
                      >
                        <i className='icons-btn mv-basico-imprimir'></i>{' '}
                        <IntlMessage id = "dashboards.disposalMaterials.printOut"/>
                      </Button>
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>

            {search && !carregando && (
              <div className='mv-container-filtros'>
                <div className='mv-filtros' onClick={() => showModalFiltros()}>
                  <IntlMessage id = "dashboards.disposalMaterials.filters"/>
                </div>
              </div>
            )}
            {modalFiltros && (
              <div className='mv-modal-filtros'>
                <div
                  className='mv-modal-filtros-header'
                  onClick={() => showModalFiltros()}
                >
                  <IntlMessage id = "dashboards.disposalMaterials.filters"/>
                </div>
                <div className='mv-modal-filtros-body'>
                  {/* { filtroValue !== 'dtvencimento' && */}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isEspecial}
                        onChange={e => changeEspecial(e.target.checked)}
                        name='descarte-especial'
                        color='primary'
                      />
                    }
                    label={<IntlMessage id = "dashboards.disposalMaterials.specialDisposal"/>}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isSepultamento}
                        onChange={e => changeSepultamento(e.target.checked)}
                        name='descarte-sepultamento'
                        color='primary'
                      />
                    }
                    label={<IntlMessage id = "dashboards.disposalMaterials.burial"/>}
                  />
                </div>
              </div>
            )}
            {search && !carregando && (
              <Card>
                <CardBody>
                  <Container fluid>
                    <DataTable
                      onSort={onSort}
                      sortField={sortName}
                      sortOrder={ascending}
                      onContextMenu={e => onChangeSelect(e)}
                      value={list}
                      pageLinkSize={20}
                      responsive={true}
                      selectionMode='single'
                      style={{ height: '100%' }}
                      columnResizeMode='expand'
                      scrollable={true}
                      //scrollHeight="50vh"
                      scrollWidth='100%'
                      resizableColumns={list.length >= 1}
                      reorderableColumns={list.length >= 1}
                      //rowsPerPageOptions={[10, 20, 50]}
                      rows={totalItensPage}
                      first={(numPagina - 1) * totalItensPage}
                      lazy={true}
                      paginator={list.length >= 1}
                      loading={carregando}
                      //loadingIcon="mv-basico-menu_secundario"
                      emptyMessage={<IntlMessage id = "dashboards.disposalMaterials.noResult"/>}
                      alwaysShowPaginator={true}
                      autoLayout={true}
                      totalRecords={totalItens}
                      footer={<RenderizarFooter total={totalItens} />}
                      onPage={event => {
                        dispatch(actions.page(event.page + 1));
                        atualizarPagina(event.page + 1);
                      }}
                    >
                      <Column
                        sortable={false}
                        field='select'
                        style={{ width: '25px' }}
                        header={
                          list.length >= 1 && (
                            <input
                              type='checkbox'
                              id='select'
                              name='select'
                              onChange={e => {
                                toggle(e.target.checked);
                              }}
                            />
                          )
                        }
                      />

                      <Column
                        sortable={list.length > 1}
                        field='exame'
                        style={{ width: '150px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.exam"/>}
                      />
                      <Column
                        sortable={list.length > 1}
                        field='pedido'
                        style={{ width: '150px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.request"/>}
                      />
                      {!isEspecial ? (
                        <Column
                          sortable={list.length >= 1}
                          field='diasavencer'
                          style={{ width: '150px' }}
                          header={<IntlMessage id = "dashboards.disposalMaterials.table.dayExpire"/>}
                        />
                      ) : (
                        <span></span>
                      )}
                      <Column
                        sortable={list.length > 1}
                        field='paciente'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.patient"/>}
                      />
                      <Column
                        sortable={list.length > 1}
                        field='pacienteNomeSocial'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.socialName"/>}
                      />
                      <Column
                        sortable={list.length > 1}
                        field='peso'
                        style={{ width: '150px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.weight"/>}
                      />
                      <Column
                        sortable={list.length > 1}
                        field='material'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.material"/>}
                      />
                      <Column
                        sortable={list.length > 1}
                        field='idFrasco'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.bottle"/>}
                      />
                      <Column
                        sortable={list.length > 1}
                        field='dataPedido'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.requestDate"/>}
                      />
                      {!isEspecial ? (
                        <Column
                          sortable={list.length > 1}
                          field='dataVencimento'
                          style={{ width: '250px' }}
                          header={<IntlMessage id = "dashboards.disposalMaterials.table.expirationDate"/>}
                        />
                      ) : (
                        <span></span>
                      )}
                    </DataTable>
                  </Container>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
        {!search && (
          <div className='icone-semdados'>
            <i className='inicial-icons mv-basico-excluir'></i>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default injectIntl(Descarte);


// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/descarte/index.js